import { useEffect } from 'react'
import Text from 'components/Text'
import If from '@mobi/components/If'
import analytics from '@mobi/libraries/analytics'
import DebtGroupHeader from 'components/DebtGroupHeader'
import Checkbox from '../Checkbox'
import CountdownTimer from 'components/CountdownTimer'
import useCountdownTimer from 'hooks/useCountdownTimer'
import { ENV } from 'gatsby-env-variables'
import { Experiment, Variant } from 'react-optimize'
import storage from 'utils/storage'
import { getOptimizeVariant } from 'utils/getOptimizeVariant'
import { navigate } from 'gatsby'
import router from 'utils/router'

import './DebtGroup.scss'

export const COUNTDOWN_OFFERS_EXPERIENCE_ID =
  ENV === 'prod' ? '094x1-GwQ6OrN__9t-ZAGQ' : '6QAD1FyCSC21N-8hQ8Uf1g'

const DebtGroup = ({
  debt,
  index,
  onGroupSelected,
  groupsSelected,
  hasCheckbox = false,
  children,
}) => {
  const lastVisitDateGetTime = storage.local.getItem('lastVisitDateGetTime')
  const runCountdownTimer = storage.local.getItem('isFirstVisit')

  const lastVisitDay = new Date(
    storage.local.getItem('lastVisitDate')
  ).getUTCDate()

  const today = new Date()

  const NOW_IN_MS =
    lastVisitDay !== today.getUTCDate()
      ? new Date().getTime()
      : lastVisitDateGetTime

  const TIME_IN_MS = 1 * 1 * 25 * 60 * 1000
  const DEADLINE_IN_MS = NOW_IN_MS + TIME_IN_MS

  const countdownCallback = () => {
    if (runCountdownTimer) {
      const timedout = storage.local.getItem('timedout')
      const pathName = router.getPathName()

      if (!timedout) {
        if (['/ofertas', '/parcelamento'].includes(pathName)) {
          storage.local.setItem('timedout', true)
        }

        if (pathName !== '/conclusao') {
          navigate('/')
        }
      }
    }
  }

  const targetDate = useCountdownTimer(DEADLINE_IN_MS, countdownCallback)

  useEffect(() => {
    getOptimizeVariant(COUNTDOWN_OFFERS_EXPERIENCE_ID)
      .then((variant) => {
        if (variant === '1' && runCountdownTimer) {
          analytics.track('elementViewed', {
            text: 'visualizou o countdown timer',
          })
        } else {
          analytics.track('elementViewed', {
            text: 'não visualizou o countdown timer',
          })
        }
      })
      .catch(console.error)
  }, [])

  return (
    <div className="debt-group" data-test="step-one-debt-group">
      <div className="debt-group-panel-label">
        <div className="debt-group-label label-left">
          <div className="fund-container">
            <DebtGroupHeader
              group={debt}
              tooltip={{
                title:
                  debt.fund === 'IResolve'
                    ? `Dívidas cedidas à ${debt.fund}`
                    : `Dívidas cedidas ao ${debt.fund}`,
                description: debt.fundTooltipText,
              }}
            />

            <If
              condition={hasCheckbox}
              renderIf={
                <Checkbox
                  dataTest="checkbox-debt"
                  tracking={{
                    dataUnique: 'b4b5b7d3-2b1a-4ff8-8851-588b042b8166',
                    text: 'Seleção de dívidas',
                  }}
                  group={debt}
                  index={index}
                  id={debt.id}
                  checked={groupsSelected?.some(({ id }) => id === debt.id)}
                  onChange={() => {
                    return onGroupSelected(debt, true)
                  }}
                />
              }
            />
          </div>
        </div>
        <div className="debt-group-label label-right">
          <div className="debt-group-label__container">
            <div className="debt-group-label__values">
              <div className="value-debt" tabIndex={0}>
                <Text
                  p
                  size={4}
                  aria-label={`De ${debt.originalValue}, por ${
                    debt?.dueDateSelected?.payment?.installmentNumber === 1
                      ? 'até'
                      : `${debt?.dueDateSelected?.payment?.installmentNumber}x de`
                  } ${debt?.dueDateSelected?.payment?.installmentValue}`}
                  data-test="card__total-value-without-discount"
                  className="value-debt__text"
                >
                  De: {debt.originalValue}
                </Text>
                <Text
                  p
                  size={4}
                  aria-hidden="true"
                  data-test="card__total-value-with-discount"
                  className="value-debt__text price-debt"
                >
                  por{' '}
                  {debt?.dueDateSelected?.payment?.installmentNumber === 1
                    ? 'até'
                    : `${debt?.dueDateSelected?.payment?.installmentNumber}x de`}{' '}
                  <b className="price-debt__value">
                    {debt?.dueDateSelected?.payment?.installmentValue}
                  </b>
                </Text>
              </div>
              <Text
                p
                size={4}
                className="discount-text"
                data-test="card__percent-value"
              >
                Desconto de <b>{debt?.dueDateSelected?.payment?.discount}</b>{' '}
                <span aria-hidden={true} role="presentation">
                  🔥
                </span>
              </Text>
            </div>
            <Experiment id={COUNTDOWN_OFFERS_EXPERIENCE_ID}>
              <Variant id="0"></Variant>
              <Variant id="1">
                <If
                  condition={runCountdownTimer && targetDate}
                  renderIf={
                    <div className="debt-group-label__discount-tag">
                      <p>Esse desconto expira em</p>
                      <CountdownTimer
                        targetDate={targetDate}
                        separator=":"
                        hideText
                      />
                    </div>
                  }
                />
              </Variant>
            </Experiment>
          </div>
          {children}
        </div>
      </div>
    </div>
  )
}

export default DebtGroup
